import React from 'react';

import PropTypes from 'prop-types';
import { Input, Label } from 'semantic-ui-react';

import MaskedInput, { conformToMask } from 'react-text-mask';

import { stripCountryCode } from './PhoneField.utils';
import { PHONE_NUMBER_MASK } from '../../../../../constants/input';
import Field from '../../../../common/Field';

const propTypes = {
  value: PropTypes.string,
  onChange: PropTypes.func.isRequired,
  title: PropTypes.string,
  placeholder: PropTypes.string,
  name: PropTypes.string,
  label: PropTypes.string,
  disabled: PropTypes.bool,
  mask: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  showMask: PropTypes.bool,
  guide: PropTypes.bool,
  countryCode: PropTypes.string,
};

const defaultProps = {
  value: '',
  title: '',
  placeholder: '',
  name: '',
  label: '',
  disabled: false,
  mask: PHONE_NUMBER_MASK,
  guide: true,
  showMask: true,
  countryCode: '+1',
};

function PhoneField({
  value,
  placeholder,
  name,
  disabled,
  label,
  onChange: onChangeProp,
  mask,
  guide,
  showMask,
  countryCode,
  ...rest
}) {
  function onChange(e) {
    const { target } = e;
    const inputValue = target.value;
    const digitsOnly = inputValue.replace(/[^0-9]/g, '');
    onChangeProp(e, target, digitsOnly);
  }

  let finalValue = value;
  finalValue = stripCountryCode(value, countryCode);
  finalValue = finalValue ? conformToMask(finalValue, mask, { guide: false }).conformedValue : '';

  return (
    <Field {...rest}>
      {label && <label>{label}</label>}
      <Input labelPosition="left">
        <Label basic>{countryCode}</Label>
        <MaskedInput
          mask={mask}
          guide={guide}
          placeholder={placeholder}
          name={name}
          value={finalValue}
          onChange={onChange}
          disabled={disabled}
          showMask={showMask}
        />
      </Input>
    </Field>
  );
}

PhoneField.propTypes = propTypes;
PhoneField.defaultProps = defaultProps;

export default PhoneField;
